export const feedbackEmail = "feedback@onefootball.com";
